import { SanityImageSource } from '@sanity/image-url/lib/types/types';
import { createPortableTextComponent, createImageUrlBuilder, createPreviewSubscriptionHook } from 'next-sanity';

import { sanityConfig } from './config';
import { supSerializer } from './serializers/marks-serializers';
import BlockSerializer from './serializers/block-serializer';

// export the configured helper functions that you need in the client-side code
// (like urlFor, usePreviewSubscription, and PortableText)

/**
 * Set up a helper function for generating Image URLs with only the asset reference data in your documents.
 * Read more: https://www.sanity.io/docs/image-url
 **/
export const urlFor = (source: SanityImageSource) => createImageUrlBuilder(sanityConfig).image(source);

// Set up Portable Text serialization
export const PortableText = createPortableTextComponent({
  ...sanityConfig,
  // Serializers passed to @sanity/block-content-to-react
  // (https://github.com/sanity-io/block-content-to-react)
  serializers: {
    container: ({ children }) => children,
    types: {
      block: BlockSerializer,
    },
    marks: {
      sup: supSerializer,
    },
  },
});

// Set up the live preview subscription hook
export const usePreviewSubscription = createPreviewSubscriptionHook(sanityConfig);
